module.exports = __webpack_public_path__ + "static/media/ferry-win.46050426.png";